import { useState, useEffect } from "react";
import { db } from "../../firebase";
import {
  doc,
  getDocs,
  collection,
  setDoc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";

const AddSale = ({ onClose, editSale }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [discount, setDiscount] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedSeries, setSelectedSeries] = useState([]);
  const [selectedAuthors, setSelectedAuthors] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [products, setProducts] = useState([]);
  const [authors, setAuthors] = useState([]);

  const seriesList = [
    "Я граюся, я вчуся",
    "Вімельбух",
    "Відкривай (енциклопедії і пізнавальні)",
    "Найкраще — дітям",
    "Казкова допомога",
    "Книжка іграшка",
    "Малювальна історія",
    "Рекомендуємо прочитати",
    "Книга нового року",
    "Батькам",
    "Дитячий путівник",
    "2000 вправ та завдань",
    "Цікаво",
    "Святкові",
    "Посібник",
    "Розумний календар",
    "Комікс-книжка",
    "3000 вправ та завдань",
    "Know how",
    "Перше кохання",
    "Книжка-іграшка",
    "Класика",
    "Діточкам",
  ];

  useEffect(() => {
    const fetchProducts = async () => {
      const snapshot = await getDocs(collection(db, "product"));
      const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      setProducts(list);
    };

    const fetchAuthors = async () => {
      const snapshot = await getDocs(collection(db, "author"));
      const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      setAuthors(list);
    };

    fetchProducts();
    fetchAuthors();

    if (editSale) {
      setTitle(editSale.title || "");
      setDescription(editSale.description || "");
      setDiscount(editSale.discountPercent ?? "");
      setSelectedProducts(editSale.appliesTo?.products || []);
      setSelectedSeries(editSale.appliesTo?.series || []);
      setSelectedAuthors(editSale.appliesTo?.authors || []);
      setStartDate(
        editSale.startDate ? String(editSale.startDate).split("T")[0] : ""
      );
      setEndDate(
        editSale.endDate ? String(editSale.endDate).split("T")[0] : ""
      );
    }
  }, [editSale]);

  const toggleValue = (value, list, setter) => {
    if (list.includes(value)) {
      setter(list.filter((v) => v !== value));
    } else {
      setter([...list, value]);
    }
  };

  const handleSubmit = async () => {
    if (!title || !discount || !endDate) {
      alert("Заповніть усі обов'язкові поля");
      return;
    }

    const id = editSale ? editSale.id : uuidv4();
    const saleRef = doc(db, "sales", id);

    const payload = {
      title,
      description,
      discountPercent: Number(discount),
      appliesTo: {
        products: selectedProducts,
        series: selectedSeries,
        authors: selectedAuthors,
      },
      startDate: startDate ? new Date(startDate).toISOString() : null,
      endDate: new Date(endDate).toISOString(),
      createdAt: serverTimestamp(),
    };

    if (editSale) {
      await updateDoc(saleRef, payload);
      alert("Розпродаж оновлено");
    } else {
      await setDoc(saleRef, payload);
      alert("Розпродаж додано");
    }

    onClose();
  };

  return (
    <div style={styles.formWrap}>
      <h2>{editSale ? "Редагувати розпродаж" : "Додати розпродаж"}</h2>

      <input
        placeholder="Назва розпродажу"
        style={styles.inputFull}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      <textarea
        placeholder="Опис"
        style={styles.textarea}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />

      <input
        type="number"
        placeholder="Знижка %"
        style={styles.inputFull}
        value={discount}
        onChange={(e) => setDiscount(e.target.value)}
      />

      <h4>Серії:</h4>
      <div style={styles.checkGrid}>
        {seriesList.map((ser) => (
          <label key={ser} style={styles.checkbox}>
            <input
              type="checkbox"
              checked={selectedSeries.includes(ser)}
              onChange={() =>
                toggleValue(ser, selectedSeries, setSelectedSeries)
              }
            />{" "}
            {ser}
          </label>
        ))}
      </div>

      <h4>Товари:</h4>
      <div style={styles.checkGrid}>
        {products.map((p) => (
          <label key={p.id} style={styles.checkbox}>
            <input
              type="checkbox"
              checked={selectedProducts.includes(p.id)}
              onChange={() =>
                toggleValue(p.id, selectedProducts, setSelectedProducts)
              }
            />{" "}
            {p.bookName || p.name}
          </label>
        ))}
      </div>

      <h4>Автори:</h4>
      <div style={styles.checkGrid}>
        {authors.map((a) => (
          <label key={a.id} style={styles.checkbox}>
            <input
              type="checkbox"
              checked={selectedAuthors.includes(a.name)}
              onChange={() =>
                toggleValue(a.name, selectedAuthors, setSelectedAuthors)
              }
            />{" "}
            {a.name}
          </label>
        ))}
      </div>

      <div>
        <label>Дата початку:</label>
        <input
          type="date"
          value={startDate || ""}
          onChange={(e) => setStartDate(e.target.value)}
        />
      </div>

      <div>
        <label>Дата завершення:</label>
        <input
          type="date"
          value={endDate || ""}
          onChange={(e) => setEndDate(e.target.value)}
        />
      </div>

      <div style={styles.actions}>
        <button style={styles.button} onClick={handleSubmit}>
          Зберегти
        </button>
        <button style={styles.buttonCancel} onClick={onClose}>
          Скасувати
        </button>
      </div>
    </div>
  );
};

const styles = {
  formWrap: {
    background: "#fff",
    padding: "20px",
    borderRadius: "8px",
    maxWidth: "700px",
    margin: "20px auto",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    fontFamily: "Arial, sans-serif",
  },
  inputFull: {
    width: "100%",
    padding: "10px",
    marginBottom: "10px",
  },
  textarea: {
    width: "100%",
    padding: "10px",
    minHeight: "60px",
    marginBottom: "10px",
  },
  checkGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
    gap: "8px",
    margin: "10px 0",
  },
  checkbox: {
    display: "flex",
    alignItems: "center",
  },
  button: {
    padding: "10px 15px",
    cursor: "pointer",
  },
  buttonCancel: {
    padding: "10px 15px",
    cursor: "pointer",
    background: "#eee",
    marginLeft: "10px",
  },
  actions: {
    marginTop: "20px",
  },
};

export default AddSale;
